<template>
  <div class="about">
    <el-container>
      <el-header style="height: 0px"></el-header>
      <el-main class="about_body">
        <div class="about_body_bgdimg">
          <div class="banner">
            <h1>奇迹ip | 全球大数据代理IP资源服务商</h1>
            <p>
              奇迹ip，专业的全球代理IP资源服务商，致力于提供稳定、安全、高效的大数据代理服务，助力企业大数据采集和品牌全球化营销
            </p>
          </div>
        </div>

        <div class="data_plate">
          <div class="data_count auto-width">
            <div class="data_card">
              <p class="d_l">220+</p>
              <p class="d_r">全球服务器部署地区</p>
            </div>
            <div class="data_card">
              <p class="d_l">亿级</p>
              <p class="d_r">代理IP资源池</p>
            </div>
            <div class="data_card">
              <p class="d_l">30000+</p>
              <p class="d_r">企业客户选择</p>
            </div>
          </div>
        </div>

        <div class="company auto-width">
          <img
              src="http://apiupss.ppfly.top/images/company_img.webp"
              alt=""
              class="l_img"
          />
          <div class="r_txt">
            <p class="second_tit">公司简介</p>
            <p class="main_text">
              奇迹ip
              ，奇迹ip网络科技有限公司2023创立，注册资金1000W，奇迹ip科技秉承着
              别具一格的产品设计理念，凭借一流的开发运作体系与高效便捷服务于网络，专注于大数据整合和分析，致力于为用户打造更实用，更便捷，更高效的产品，让用户获得专业及时的服务，给用户带来更大的利益。
              奇迹ip始终坚持，以服务用户为宗旨，积极探索，不断创新，致力于行业先锋，真正领航互联网行业！从创业之初至今，奇迹ip科技自主研发的项目3款，游戏，跨境电商，erp

            </p>
            <p class="main_text">

            </p>
          </div>
        </div>

        <div class="cooperation">
          <div class="coop auto-width">
            <h2>全球企业合作</h2>
            <p class="h2_tip">
              奇迹ip赋能超过30000家企业合作伙伴，服务覆盖电商贸易、旅游、金融、游戏等多个行业
            </p>
            <div class="user_coop">
              <div class="comment_card">
                我们的用户这样评价“奇迹ip拥有专业的技术、运营、商务团队，具备丰富的大数据采集行业经验，总能在第一时间为我们提供产品与技术支持”
              </div>
              <img
                  src="http://apiupss.ppfly.top/images/about_2.png"
                  alt=""
                  class="about_2"
              />
            </div>
          </div>
        </div>

        <div class="values auto-width">
          <h2>企业价值观</h2>
          <p class="h2_tip">
            奇迹ip希望通过持续创新和卓越服务，引领代理IP服务领域的未来发展方向，助力用户实现数据驱动的业务增长
          </p>
          <div class="values_box">
            <div class="val_card">
              <img
                  src="http://apiupss.ppfly.top/images/val_card1.svg"
                  alt=""

              />
              <p class="card_title">客户至上</p>
              <p class="card_text">
                以客户需求为导向，以客户满意为目标，以客户成功为荣誉
              </p>
            </div>
            <div class="val_card">
              <img
                  src="http://apiupss.ppfly.top/images/val_card2.svg"
                  alt=""

              />
              <p class="card_title">创新突破</p>
              <p class="card_text">
                不断创新和优化产品服务提升自身能力和水平，追求卓越和领先
              </p>
            </div>
            <div class="val_card">
              <img
                  src="http://apiupss.ppfly.top/images/val_card3.svg"
                  alt=""

              />
              <p class="card_title">社会责任</p>
              <p class="card_text">
                遵守法律法规，保护用户隐私，维护网络安全，履行社会责任
              </p>
            </div>
          </div>
        </div>

        <div class="applyintro auto-width">
          <h2>联系我们</h2>
          <div class="company_box">
            <div class="ci_card">
              <img src="http://apiupss.ppfly.top/images/ci_icon1.svg" alt=""/>
              <div class="ci_info">
                <p class="ci_name">公司地址</p>
                <p class="ci_text">
                  北京创业园区<br/>
                </p>
              </div>
            </div>
            <div class="ci_card">
              <img src="http://apiupss.ppfly.top/images/ci_icon1.svg" alt=""/>
              <div class="ci_info">
                <p class="ci_name">网站业务合作</p>
                <p class="ci_text">
                  电话：{{ this.$tel }}<br/>
                  Email：{{ this.$email }}
                </p>
              </div>
            </div>
            <div class="ci_card">
              <img src="http://apiupss.ppfly.top/images/ci_icon1.svg" alt=""/>
              <div class="ci_info">
                <p class="ci_name">联系方式</p>
                <p class="ci_text">
                  Email：{{ this.$email }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <Footer></Footer>
    </el-container>
  </div>
</template>
<script>
import Footer from "@/components/footer/footer.vue";

export default {
  components: {Footer},
  name: "about",
  data() {
    return {};
  },
  methods: {},
  created() {
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.about_body_bgdimg {
  height: 400px;
  background: url(http://apiupss.ppfly.top/images/new_banner.webp);
}

.data_plate {
  border-bottom: 1px solid #e7e9ed;
}

.banner h1 {
  font-family: SourceHanSansCN-Medium;
  font-weight: 600;
  font-size: 54px;
  color: #edf3fc;
  line-height: 76px;
  letter-spacing: 3px;
  margin: 0;
  padding-top: 100px;
}

.banner p {
  font-size: 20px;
  color: #edf3fc;
  line-height: 36px;
  margin-top: 24px;
}

.data_plate .data_count {
  width: 70%;
  margin: 0 auto;
  height: 203px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.data_plate .data_card {
  display: flex;
  align-items: center;
}

.data_plate .data_card .d_l {
  font-weight: 600;
  margin-right: 30px;
  font-size: 48px;
  color: #161c2d;
  line-height: 58px;
  font-family: SourceHanSansCN-Medium;
}

.data_plate .data_card .d_r {
  font-weight: 400;
  font-size: 17px;
  color: #161c2d;
  line-height: 29px;
  width: 181px;
}

.company {
  width: 70%;
  margin: 0 auto;
  display: flex;
  margin-top: 177px;
  align-items: center;
  margin-bottom: 176px;
  justify-content: space-between;
}

.company .r_txt {
  max-width: 560px;
}

.company .r_txt .first_top {
  font-size: 24px;
  color: #1053f3;
  line-height: 28px;
  font-family: SourceHanSansCN-Medium;
}

.company .r_txt .second_tit {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 32px;
  color: #20232a;
  line-height: 42px;
  margin-top: 15px;
}

.company .r_txt .main_text {
  font-size: 19px;
  color: #585d69;
  line-height: 33px;
  margin-top: 26px;
  text-align: left;
}

.cooperation {
  background: url(https://apiupss.ppfly.top/images/cooperation_bg.jpg) no-repeat 50%;
  background-size: cover;
  padding-top: 142px;
  padding-bottom: 179px;
}

.cooperation .coop {
  max-width: 1200px;
}

.auto-width {
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
}

h2 {
  font-size: 40px;
  color: #1b2336;
  line-height: 44px;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
}

.cooperation .coop .h2_tip {
  color: rgba(18, 17, 39, 0.72);
}

.h2_tip {
  font-size: 20px;
  color: #515264;
  line-height: 36px;
  text-align: center;
  margin-top: 27px;
}

.cooperation .coop .user_coop {
  margin-top: 137px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.cooperation .coop .user_coop .comment_card {
  width: 100%;
  max-width: 543px;
  height: 334px;
  background: #edf3fc;
  box-shadow: 0 6px 46px 0 rgba(161, 188, 221, 0.46);
  border-radius: 25px;
  font-size: 19px;
  color: #585d69;
  line-height: 33px;
  text-align: left;
  position: relative;
  box-sizing: border-box;
  padding: 117px 46px;
}

.cooperation .coop .user_coop .comment_card:before {
  position: absolute;
  content: "";
  background: url(https://apiupss.ppfly.top/images/about_marks1.png) no-repeat 50%;
  width: 92px;
  height: 83px;
  top: -51px;
  left: -26px;
}

.cooperation .coop .user_coop .comment_card:after {
  position: absolute;
  content: "";
  background: url(https://apiupss.ppfly.top/images/about_marks2.png) no-repeat 50%;
  width: 92px;
  height: 83px;
  bottom: -23px;
  right: -22px;
}

.cooperation .coop .user_coop .about_2 {
  width: 100%;
  max-width: 543px;
}

.values {
  margin-top: 150px;
}

.auto-width {
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
}

.values .values_box {
  margin-top: 105px;
  display: flex;
  justify-content: space-between;
}

.values .values_box .val_card {
  max-width: 373px;
  min-height: 373px;
  box-sizing: border-box;
  padding: 48px 32px 0;
  background: #edf3fc;
  border-radius: 20px;
  border: 1px solid #eff0f6;
  text-align: center;
}

.values .values_box .val_card img {
  width: 86px;
  height: 86px;
}

.values .values_box .val_card .card_title {
  font-size: 28px;
  color: #0b0a33;
  line-height: 42px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  margin-top: 45px;
}

.values .values_box .val_card .card_text {
  margin-top: 22px;
  font-size: 18px;
  color: #7a7d9c;
  line-height: 30px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
}

.applyintro {
  margin-top: 142px;
  margin-bottom: 182px;
}

.applyintro .company_box {
  display: flex;
  justify-content: space-between;
  margin-top: 99px;
}

.applyintro .company_box .ci_card {
  display: flex;
}

.applyintro .company_box .ci_card img {
  width: 60px;
  height: 60px;
  margin-right: 22px;
}

.applyintro .company_box .ci_card .ci_info .ci_name {
  font-family: SourceHanSansCN-Medium;
  font-size: 20px;
  color: #1b2336;
  line-height: 22px;
  text-align: left;
}

.applyintro .company_box .ci_card .ci_info .ci_text {
  font-size: 20px;
  color: #8b8a97;
  line-height: 30px;
  margin-top: 20px;
  text-align: left;
}
</style>
